import { forwardRef, type FC } from 'react'
import { ReactComponent as ExclamationIcon } from '../../../../icons/assets/ExclamationMarkFill.svg'
import { ReactComponent as InfoIcon } from '../../../../icons/assets/Info.svg'
import { ReactComponent as CloseIcon } from '../../../../icons/assets/X.svg'
import * as S from './ProductAlert.styles'

export type ProductAlertVariant = 'warning' | 'info'

const ICON_MAP: Record<ProductAlertVariant, FC> = {
  warning: ExclamationIcon,
  info: InfoIcon,
}

type ProductAlertProps = {
  variant: ProductAlertVariant
  dataWarning?: string
  text: string
  ctaText?: string
  onCtaClick?: () => void
  onDismiss?: () => void
}

const ProductAlert = forwardRef<HTMLDivElement, ProductAlertProps>(
  ({ variant, dataWarning, text, ctaText, onCtaClick, onDismiss }, ref) => {
    const IconComponent = ICON_MAP[variant]

    return (
      <S.Container
        ref={ref}
        data-testid="cart-item-warning"
        data-warning={dataWarning}
      >
        <S.Icon>
          <IconComponent />
        </S.Icon>
        <S.TextWrapper>
          {text}{' '}
          {ctaText && onCtaClick && (
            <S.Cta onClick={onCtaClick} data-testid="cart-item-warning-cta">
              {ctaText}
            </S.Cta>
          )}
        </S.TextWrapper>
        {onDismiss && (
          <S.Dismiss
            onClick={onDismiss}
            data-testid="cart-item-warning-dismiss"
          >
            <CloseIcon />
          </S.Dismiss>
        )}
      </S.Container>
    )
  }
)

export default ProductAlert
